import { makeStyles } from '@material-ui/core';

export const PROXIMA_NOVA_FONT_FAMILY = 'ProximaNova,Helvetica Neue,Arial,sans-serif';
export const PROXIMA_NOVA_T_FONT_FAMILY = 'ProximaNovaT,Helvetica Neue,Arial,sans-serif';

const applyGlobalStyles = makeStyles({
  '@global': {
    body: {
      margin: 0,
    },
    fieldset: {
      border: 'none',
      padding: 0,
    },
    '.material-icons': {
      width: 'auto',
      minWidth: '1em',
    },
    '.button-start-icon': {
      marginRight: 5,
      fontSize: '1rem',
    },
    '& i[class*="materialIcons"]': {
      display: 'none',
    },
    '.material-icon-font-loaded': {
      '& i[class*="materialIcons"]': {
        display: 'block',
      },
    },
    '.headBarFixed': {
      position: 'fixed',
      top: 0,
      left: 0,
      background: '#fff !important',
      width: '100%',
      zIndex: '9999',
      boxShadow: `0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12),
      0 4px 5px 0 rgba(0, 0, 0, 0.14)`,
    },
    '#app': {
      '& .MuiGrid-spacing-xs-2': {
        width: '100%',
        margin: 0,
        '& > .MuiGrid-item': {
          padding: 0,
        },
      },
      '& button, & [role="button"]': {
        textTransform: 'none',
        fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      },
      '& select, & a, & input, & h5, & label, & legend': {
        fontFamily: PROXIMA_NOVA_FONT_FAMILY,
      },
    },
    '#client-snackbar': {
      maxWidth: '40vw',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    '@font-face': [
      {
        fontFamily: 'ProximaNova',
        src: `local('ProximaNova-regular'),
            url(/fonts/proximanova-regular.woff2) format("woff2"),
            url(/fonts/proximanova-regular.woff) format("woff"),
            url(/fonts/proximanova-regular.ttf) format("truetype")`,
        fontWeight: 'normal',
        fontWtyle: 'normal',
        fontWtretch: 'normal',
      },
      {
        fontFamily: 'ProximaNova',
        src: `local('ProximaNova-bold'),
            url(/fonts/proximanova-bold.woff2) format("woff2"),
            url(/fonts/proximanova-bold.woff) format("woff"),
            url(/fonts/proximanova-bold.ttf) format("truetype")`,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
      },
      {
        fontFamily: 'ProximaNovaT',
        src: `local('ProximaNovaT'),
            local('proximanova-thin'),
            url(/fonts/proximanova-thin.woff2) format("woff2"),
            url(/fonts/proximanova-thin.woff) format("woff"),
            url(/fonts/proximanova-thin.ttf) format("truetype")`,
        fontWeight: 100,
        fontStyle: 'normal',
        fontStretch: 'normal',
      },
    ],
    '.text-ellipsis': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
    '.scroll-bar': {
      '&::-webkit-scrollbar': {
        width: 8,
        height: 8,
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-track': {
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
        borderRadius: 6,
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: 6,
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
        backgroundColor: '#6D7278',
      },
    },
    '.field-Wrap': {
      boxShadow: 'none',
    },
    '.limited-select': {
      padding: '16px',
      marginBottom: '16px',
      background: '#fff',
    },
  },
});

export default applyGlobalStyles;
